<div class="property-set-info-dialog">
  <div class="dialog confirm-dialog">
    <mat-icon class="close_icon" aria-hidden="false" aria-label="Close icon" (click)="onClose()">close</mat-icon>
    <div mat-dialog-content class="confirm-container">
      <!-- VIEW MODE -->
      <h1 class="dialog-title">NOTICE</h1>
      <div class="viewmode">
        <span><mat-icon class="mat-icon" svgIcon="circle-info-icon"></mat-icon></span>
        <span id="e2e-description">
          <span class="message">
            <ng-container *ngIf="data?.context !== 'remove'; else removeMessage">
              <span class="message" [innerHTML]="data?.addingMessage"></span>
            </ng-container>
          </span>
        </span>
      </div>
      <div class="property-set-dialog-actions">
        <button mat-flat-button color="primary" class="fx--mt-sm" (click)="onClose()">OK</button>
      </div>
    </div>
    <ng-template #removeMessage>
      <span class="message" [innerHTML]="data.removingMessage"></span>
    </ng-template>
  </div>
</div>
